"use strict";
var list = document.querySelector("ul");
function getSalaryNumber(salary) {
    return Number(salary.replace(/[$,]/g, ""));
}
function sortList(listElement) {
    var items = Array.from(listElement.children);
    items.sort(function(a, b) {
        var salaryA = getSalaryNumber(a.dataset.salary);
        var salaryB = getSalaryNumber(b.dataset.salary);
        return salaryB - salaryA;
    });
    items.forEach(function(item) {
        return listElement.appendChild(item);
    });
}
function getEmployees(listElement) {
    var people = Array.from(listElement.children);
    return people.map(function(person) {
        var name1 = person.textContent.trim();
        var position = person.dataset.position;
        var salary = person.dataset.salary;
        var age = person.dataset.age;
        return {
            name: name1,
            position: position,
            salary: salary,
            age: age
        };
    });
}
sortList(list);
getEmployees(list);

//# sourceMappingURL=index.ac27cf13.js.map
